export default __webpack_public_path__ + "static/media/hbs-blk-1.7275853c.png";